import React from 'react'
import { useFadeIn } from '../../components/animation/useFadeIn'
import {
  NOTIFICATION_STATUS,
  notificationToLink,
  NotificationType,
  useNotifications,
} from '../../hooks/useNotifications'
import { ListItemContent } from '../../components/display/ListItemContent'
import formatDistance from 'date-fns/formatDistance'
import { Link } from 'react-router-dom'
import { Button } from 'antd'

export const NotificationPage = () => {
  const { animated, spring } = useFadeIn()

  const now = new Date()
  const { data } = useNotifications('')
  const sorted = [...data].sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())

  return (
    <>
      <animated.div style={spring} className="d-flex flex-column flex-fill">
        <div className="container my-5 ">
          <div className="row" style={{}}>
            <div className="col-12 mb-3">
              <h1>Notifications</h1>
            </div>
          </div>
          <div className="row" style={{}}>
            {sorted.map((notification: NotificationType, index) => {
              const title = notification.configId.content.banner.title
              const body = notification.configId.content.banner.body
              const button = notification.configId.content.banner.button

              const link = notificationToLink(notification)
              const d = formatDistance(new Date(notification.createdAt), now, {
                addSuffix: true,
              })

              const btnType = notification.status === NOTIFICATION_STATUS.SEEN ? 'default' : 'primary'

              return (
                <div key={index} className="col-12 rounded-2 d-flex bg-white mb-3 px-4 pt-3 pb-3 block-shadow">
                  <div className="w-50">
                    <p className="mb-0 text-black p-mini opacity-50">{d}</p>
                    <p className="fw-bold">{title}</p>
                    <p className="opacity-75">{body}</p>
                  </div>
                  <div className="w-50 d-flex align-items-center justify-content-end">
                    <ListItemContent
                      label="Participant"
                      style={{ width: '50%' }}
                      title={notification.target.subjectId.displayId}
                    ></ListItemContent>
                    <ListItemContent
                      label="Status"
                      style={{ width: '40%' }}
                      title={notification.status}
                    ></ListItemContent>
                    <Link to={link}>
                      <Button type={btnType}>{button}</Button>
                    </Link>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </animated.div>
    </>
  )
}
